import { Image } from '../../../../../global/interfaces/products';

export enum ProductImageBoxMediaSize {
  MEDIUM = 'MEDIUM'
}
export interface ProductImageBoxMediaProps {
  images: Image[];
  boxLength: number;
}
